// extracted by mini-css-extract-plugin
export var content = "_n6-1";
export var fullScreen = "_n6-0";